// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preview_wrapper__2piqb","content":"preview_content__Fawvq","preview":"preview_preview__25GQo","mobileContainar":"preview_mobileContainar__22AAO"};